const fields = [
    {label: "Tittel på nyhetsbrev", name: "title", errMsg: "Du må oppgi en tittel"},
    {label: "Emne", name: "subject", errMsg: "Du må oppgi et emne"},
    {label: "Innhold", name: "body", errMsg: "Du må gi nyhetsbrevet innhold"},
    {label: "Mottakere", name: "recipients", errMsg: "Du må oppgi minst en mottaker"}
];

export default fields;